<div class="help" [matTooltip]="translateKey | translate" [matTooltipClass]="'texts-help-tooltip'">
  <i class="msi-question-circle"></i>
</div>
